import { authFetch } from './interceptors';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://metriciqkontrol.online';

export const authAPI = {
  login: async (credentials) => {
    const url = `${API_BASE_URL}/auth/jwt/create/`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || 'Credenciales inválidas');
    }

    return response.json();
  },

  // ✅ CORREGIDO: Usar la ruta correcta para registro
  register: async (userData) => {
    const url = `${API_BASE_URL}/api/user/v1/users/`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.username?.[0] || 
        errorData.email?.[0] || 
        errorData.detail || 
        'Error en el registro'
      );
    }

    return response.json();
  },

  verifyToken: async (token) => {
    const url = `${API_BASE_URL}/auth/jwt/verify/`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    });

    return response.ok;
  },

  refreshToken: async (refresh) => {
    const url = `${API_BASE_URL}/auth/jwt/refresh/`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh }),
    });

    if (!response.ok) {
      throw new Error('Token refresh failed');
    }

    return response.json();
  },

  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
  }
};
